import { useCallback } from 'react'
import { requestCreateCriterionE } from 'api/criterionE'

const useCriterionEPersistence = ({ siteId, siteHistoryId, criterionEId, updateCriterionE }) => {
  const createAndUpdate = useCallback(async (payload) => {
    const createdCriterionE = await requestCreateCriterionE(siteId, siteHistoryId)
    const createdId = createdCriterionE?.site_irreplaceability_id || createdCriterionE?.site_irreplaceability_history_id
    if (!createdId) return
    await updateCriterionE({ criterionEId: createdId, ...payload })
  }, [siteHistoryId, siteId, updateCriterionE])

  const persistField = useCallback(async (payload) => {
    if (!criterionEId) {
      return createAndUpdate(payload)
    }
    return updateCriterionE({ criterionEId, ...payload })
  }, [createAndUpdate, criterionEId, updateCriterionE])

  return { persistField, createAndUpdate }
}

export default useCriterionEPersistence

